export default __webpack_public_path__ + "static/media/cabourg17.2f95f180.jpg";